import { Toaster } from 'sonner'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ServerStatusProvider } from '@/contexts/ServerStatusContext'
import { BridgePage } from '@/pages/BridgePage'
// ReferralPage / ReferralDashboardPage / RewardsPage intentionally NOT imported — their routes are
// disabled (redirected) while referrals are toggled off. Re-import when the server-flag gate lands.
import { TermsPage } from '@/pages/TermsPage'
import { PrivacyPage } from '@/pages/PrivacyPage'
import { useReferralCapture } from '@/hooks/useReferralCapture'
import { useReferralAttribution } from '@/hooks/useReferralAttribution'
import { BetaBanner } from '@/components/BetaBanner'
import { TermsGate } from '@/components/TermsGate'

function App() {
  useReferralCapture()
  useReferralAttribution()

  return (
    <ServerStatusProvider>
      <BetaBanner />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'var(--color-bg-card)',
            border: '1px solid var(--color-border-subtle)',
            color: 'var(--color-text-primary)',
          },
          className: 'parse-toast',
        }}
        richColors
      />
      <TermsGate />
      <Routes>
        <Route path="/" element={<BridgePage />} />
        {/* Referral / rewards routes DISABLED while referrals are toggled off (backend REFERRALS_ENABLED
            kill switch). The nav/footer links are already hidden; these redirects also block direct-URL
            access so /refer, /refer/dashboard, /rewards can't be reached. Interim hardcode — the proper
            fix is a server-exposed referralsEnabled flag (GET /api/config) so the FE follows the backend
            switch without a redeploy (tracked follow-up). */}
        <Route path="/refer" element={<Navigate to="/" replace />} />
        <Route path="/refer/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/rewards" element={<Navigate to="/" replace />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<BridgePage />} />
      </Routes>
    </ServerStatusProvider>
  )
}

export default App
